import { LOCALE_BY_LANGUAGE } from '../../components/format-money';
import type { SupportedLanguage } from '../../i18n';

const BPS_PER_UNIT = 10_000;

/**
 * Shared by Home (M1) and the Channels tab (S9 R20).
 * `Intl` formatters built once per language and kind, then reused: Home re-renders every 5 s
 * (M7), and building an `Intl` formatter is far slower than calling one.
 */
const numberFormats = new Map<string, Intl.NumberFormat>();

function numberFormat(
  kind: string,
  language: SupportedLanguage,
  options: Intl.NumberFormatOptions,
): Intl.NumberFormat {
  const key = `${kind}|${language}`;
  let format = numberFormats.get(key);
  if (format === undefined) {
    format = new Intl.NumberFormat(LOCALE_BY_LANGUAGE[language], options);
    numberFormats.set(key, format);
  }
  return format;
}

/**
 * Formats integer basis points as a percentage (M1 R9, R13: ratios travel as basis points).
 *
 * @example formatBps(80, 'fr') // "0,8 %"
 */
export function formatBps(bps: number, language: SupportedLanguage): string {
  return numberFormat('bps', language, {
    style: 'percent',
    maximumFractionDigits: 2,
  }).format(bps / BPS_PER_UNIT);
}

/** Formats a lot size with two decimals, as on mockup 1 ("0,12 lot"). */
export function formatLots(lots: number, language: SupportedLanguage): string {
  return numberFormat('lots', language, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(lots);
}
